export enum RecoveryStepEnum{
    Recovery,
    RecoverySent,
    NoAccountAccess,
    Captcha,
    RecoverySendEmail,
    RecoveryPhoneCode,
    CreateNewPassword,
    PasswordSaving,
    RecoveryCodeOutdated,
    RecoveryAccount = 9
}
export enum RegisterStepEnum {
    Start,
    PhoneSent,
    PhoneSubmit,
    MailSent,
    MailSubmit,
}
export enum CitizenshipIdEnum {
    Russian = 1,
    Foreign= 2
}

export enum RecoveryType {
    Phone = 1,
    Email = 2
}